var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"correctness-box",class:{ correct: _vm.correct, selected: _vm.selected, incorrect: !_vm.correct }},[_c('div',{staticClass:"icon",class:{ correct: _vm.correct, selected: _vm.selected, incorrect: !_vm.correct }})])
}
var staticRenderFns = []

export { render, staticRenderFns }